/* [RR feat] Sicherheitsnetz fuer den Abo-Rhythmus im Kaufformular.
   Ausgangslage: Der Verkaufsplan kommt aus dem Appstle-Widget, das erst per JavaScript erscheint. Der
   Kaufen-Button ist dagegen sofort klickbar. Wer vorher klickt, oder wessen Browser das Appstle-Script
   blockiert, bestellte ohne Abo. Solange die Boxen auf "nur Abo" standen, hat Shopify das abgewiesen; seit
   dem Abschalten nicht mehr (Bestellung 1141).

   Drei Schichten:
   1. snippets/buy-buttons.liquid rendert serverseitig ein verstecktes Feld selling_plan mit dem Standardplan.
      Das wirkt auch ohne JavaScript, weil das Formular dann klassisch abgesendet wird. Das Snippet bindet
      dieses Script gleich mit ein, damit Feld und Abgleich nie getrennt ausgeliefert werden.
   2. Dieses Script gleicht beim Absenden ab: Liefert ein fremdes Feld im selben Formular einen Wert, schweigt
      unseres. Sitzt die Auswahl ausserhalb des Formulars, wie bei Appstle, wird ihr Wert gespiegelt. Liegt
      nichts vor, greift der Standardplan. Alle Abfragen sind auf das Produkt rund um das Formular begrenzt,
      damit ein zweites Widget (Schnellkauf, Ergaenzungsprodukte) nicht hineinfunkt.
   3. Nach dem Hinzufuegen wird die Antwort geprueft. Fehlt der Plan an der Position, wird er ueber die
      Warenkorb-Schnittstelle nachgetragen und der Drawer neu gerendert.
   Hintergrund: docs/abo-plan-sicherung.md */
(function () {
  if (window.rrPlanGuardLoaded) return;
  window.rrPlanGuardLoaded = true;

  var FIELD = '[name="selling_plan"]';

  function fallbacks() {
    return Array.prototype.slice.call(document.querySelectorAll('input[data-rr-plan-fallback]'));
  }

  function formOf(el) {
    return el.form || (el.closest ? el.closest('form') : null);
  }

  /* Suchbereich: der Produktbereich um das Formular. Ohne diese Grenze wuerde ein zweites Appstle-Widget auf
     derselben Seite (Schnellkauf-Dialog, Ergaenzungsprodukte) seinen Plan in dieses Formular spiegeln. */
  function scopeOf(form) {
    if (!form || !form.closest) return document;
    return form.closest('product-info') || form.closest('.shopify-section') || document;
  }

  function valueOf(el) {
    if (el.type === 'radio' || el.type === 'checkbox') return el.checked && el.value ? el.value : '';
    return el.value || '';
  }

  /* Wert eines fremden Feldes, das zu diesem Formular gehoert und deshalb ohnehin mitgesendet wird. */
  function submittedPlan(form, mine) {
    var value = '', nodes = form.querySelectorAll(FIELD);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] === mine) continue;
      value = valueOf(nodes[i]) || value;
    }
    return value;
  }

  /* Sichtbare Auswahl des Widgets ausserhalb des Formulars. Appstle rendert sein Widget neben dem Formular,
     sein Wert wandert also nicht von allein in die Formulardaten; wir spiegeln ihn. */
  /* Gehoert der Knoten zu genau diesem Produkt? product-info umschliesst auf der Produktseite auch die
     Ergaenzungsprodukte und deren Schnellkauf-Dialoge; die bringen eigene product-info-Elemente mit. Ein
     Knoten zaehlt nur, wenn sein naechstes product-info dasselbe ist wie unseres. */
  function inScope(el, scope) {
    if (el.closest) {
      if (el.closest('quick-add-modal') || el.closest('product-recommendations')) return false;
      if (scope !== document && el.closest('product-info') !== scope) return false;
    }
    return true;
  }

  function visiblePlan(form, mine) {
    var value = '', scope = scopeOf(form), nodes = scope.querySelectorAll(FIELD);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el === mine || el.form === form) continue;
      if (el.form && el.form !== form) continue;
      if (!inScope(el, scope)) continue;
      value = valueOf(el) || value;
    }
    if (!value) {
      /* Appstles Auswahlfeld traegt nicht immer den Namen selling_plan. */
      var sels = scope.querySelectorAll('select.appstle_select');
      for (var j = 0; j < sels.length; j++) {
        if (!inScope(sels[j], scope)) continue;
        if (/^\d+$/.test(String(sels[j].value || '').trim())) { value = String(sels[j].value).trim(); break; }
      }
    }
    return value;
  }

  function arm(input, form, value) {
    if (!input.getAttribute('name')) input.setAttribute('name', 'selling_plan');
    input.value = value || input.getAttribute('data-rr-plan-default') || '';
    /* Sollte doch einmal ein zweites, leeres Feld im Formular stehen, entscheidet die Reihenfolge: unseres
       steht als letztes und gewinnt damit beim Auswerten des Aufrufs. */
    if (form && form.lastElementChild !== input) form.appendChild(input);
  }

  function disarm(input) {
    if (input.getAttribute('name')) input.removeAttribute('name');
  }

  function sync(input) {
    var form = formOf(input);
    if (!form) return;
    if (submittedPlan(form, input)) disarm(input);
    else arm(input, form, visiblePlan(form, input));
  }

  function syncAll() {
    fallbacks().forEach(sync);
  }

  /* Vor product-form.js: dessen Submit-Handler liest FormData in der Bubble-Phase. */
  document.addEventListener(
    'submit',
    function (e) {
      fallbacks().forEach(function (input) {
        if (formOf(input) === e.target) sync(input);
      });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();

  /* Das Widget erscheint spaeter und kann sich noch aendern. Gebuendelt, damit Slider und Karussells auf der
     Seite nicht bei jeder Regung drei dokumentweite Abfragen ausloesen. */
  if (window.MutationObserver) {
    var pending = null;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; syncAll(); }, 120);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
      if (pending) { clearTimeout(pending); pending = null; }
    }, 30000);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && (e.target.matches(FIELD) || e.target.matches('select.appstle_select'))) syncAll();
  });

  /* Schicht 3: Antwort von /cart/add.js pruefen und die Position noetigenfalls nachbessern. */
  /* Plan zu einer Warenkorb-Position: ueber die Produkt-ID am Rueckfallfeld. Das ist zuverlaessiger als sich
     zu merken, welches Formular zuletzt abgeschickt wurde; auf der Produktseite gibt es mehrere, und ein
     dazwischen abgeschicktes fremdes Formular wuerde die Zuordnung sonst verlieren. */
  function planForProduct(productId) {
    var input = fallbacks().filter(function (i) {
      return String(i.getAttribute('data-rr-plan-product') || '') === String(productId);
    })[0];
    if (!input) return '';
    var form = formOf(input);
    if (!form) return input.getAttribute('data-rr-plan-default') || '';
    return submittedPlan(form, input) || visiblePlan(form, input) || input.getAttribute('data-rr-plan-default') || '';
  }

  function repair(item, plan) {
    var root = (window.routes && window.routes.cart_url) || '/cart';
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    var drawer = document.querySelector('cart-drawer');
    var sections =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
    return fetch(root + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = 0;
        (cart.items || []).forEach(function (i, idx) { if (i.key === item.key) line = idx + 1; });
        if (!line) return null;
        var body = { line: line, quantity: item.quantity || 1, selling_plan: plan };
        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }
        return fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        if (!state || !Array.isArray(state.items)) return;
        if (drawer && state.sections && typeof drawer.renderContents === 'function') drawer.renderContents(state);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rr-plan-guard', cartData: state });
        }
      })
      .catch(function (e) { console.error('[rr-plan-guard] Nachtragen des Verkaufsplans fehlgeschlagen', e); });
  }

  function watchCart() {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS || !PUB_SUB_EVENTS.cartUpdate) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !event.cartData) return;
      var data = event.cartData;
      var items = Array.isArray(data.items) ? data.items : [data];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || !it.key || it.selling_plan_allocation) continue;
        /* Nur Produkte, fuer die dieses Theme einen Standardplan rendert. Der Schnellkauf der
           Ergaenzungsprodukte hat keinen und bleibt damit unberuehrt. */
        var plan = planForProduct(it.product_id);
        if (!plan) continue;
        console.warn('[rr-plan-guard] Position ohne Verkaufsplan angelegt, Plan wird nachgetragen.', it.key);
        return repair(it, plan);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
